// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"deb63d57","4083":"9c37e26e","4285":"d44dfa87","5464":"9c37e26e","6375":"5f096d51","6718":"85f1c87b","7638":"2f9f51c9","8622":"ca7937bc","9285":"9c37e26e","9791":"d44dfa87"}[chunkId] + ".chunk.css";
};